import React from "react";
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  CardMedia,
  useTheme,
} from "@mui/material";
import img1 from "./img/profileImg.png";
import img2 from "./img/dashboard.png";
import img3 from "./img/dash.png";

const cardData = [
  {
    title: "Verify Payment status from ",
    highlight: "User Profile",
    highlightColor: "#00c853",
    description:
      "You can easily verify the payment status of customers individually from the payments section under the user profile of a customer.",
    image: img1,
    bgColor: "rgba(232, 245, 233, 0.8)", // #e8f5e9 with ~0.9 opacity
  },
  {
    title: "View All Payments Received in One ",
    highlight: "Unified Dashboard",
    highlightColor: "#1e88e5",
    description:
      "Ensure a seamless transition from automated chatbot interactions to live human support, maintaining conversation flow and customer satisfaction.",
    image: img2,
    bgColor: "rgb(243, 230, 255, 0.8)", // #e3f2fd with ~0.9 opacity
  },
  {
    title: "Works Seamlessly with ",
    highlight: ["Razorpay", "PayU"],
    highlightColor: "#00c853",
    description:
      "Connect your Payment Gateway to Vertex Suite and start collecting payment on WhatsApp.",
    image: img3,
    bgColor: "rgb(197, 227, 245, 0.8)", // #f1f8e9 with ~0.9 opacity
  },
];

const cardStyles = {
  borderRadius: 4,
  boxShadow: 6,
  transition: "transform 0.3s ease",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  height: "100%",
  "&:hover": {
    transform: "translateY(-10px)",
  },
};

const CardsMenu1 = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        background: `url('bg3.svg')`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundAttachment: 'fixed',
        backgroundRepeat: 'no-repeat',
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          py: { xs: 5, md: 10 },
          px: { xs: 2, md: 8 },
          width: { xl: "74%", lg: "79%", md: "90%", sm: "90%" },
        }}
      >
        <Grid container spacing={4} justifyContent="center">
          {cardData.map((card, index) => (
            <Grid item xs={12} md={4} key={index} display="flex">
              <Card sx={{ ...cardStyles, backgroundColor: card.bgColor }}>
                <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    WebkitMaskImage: "linear-gradient(black, transparent)",
                    maskImage: 'linear-gradient(to bottom, black 70%, rgba(0, 0, 0, 0.3) 80%, transparent 100%)',
                }}
                >
                  <CardMedia
                    component="img"
                    image={card.image}
                    alt={card.highlight.toString()}
                    sx={{ width: "100%", height: "auto", borderRadius: 2 }}
                  />
                </Box>

                <Box p={3}>
                  <Typography variant="h5" fontWeight="bold" mt={2} mb={2}>
                    {card.title}
                    {Array.isArray(card.highlight) ? (
                      card.highlight.map((text, i) => (
                        <Box
                          key={i}
                          component="span"
                          color={card.highlightColor}
                          ml={i > 0 ? 0.8 : 0}
                        >
                          {text}
                          {i < card.highlight.length - 1 && ", "}
                        </Box>
                      ))
                    ) : (
                      <Box component="span" color={card.highlightColor}>
                        {card.highlight}
                      </Box>
                    )}
                  </Typography>
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{ fontSize: "1rem" }}
                  >
                    {card.description}
                  </Typography>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default CardsMenu1;
